import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";
import Paginate from "vuejs-paginate";

import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);
Vue.component("paginate", Paginate);

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
